<h3>Invoices  <span class="highlight">(Click on an invoice to edit)</span> </h3>
<a routerLink="/addinvoice" routerLinkActive="active" class="btn btn-default">Add Invoice</a>
<br><br>
<div> 
    <form  [formGroup]="myForm" novalidate>

        Show invoices with Uploaded Date of: <select id="datelimit" [formControl]="myFormControl" formControlName="datelimit"  required >
            @for (year of years; track year) {
                <option value={{year}}>{{year}}</option>
            }
        </select>
        <br>

    <!--<input type=radio id="datelimit" formControlName="datelimit" value = "6" (click)="refreshInvoices('6'); $event.stopPropagation()"> Invoices from last 6 months &nbsp;
    <input type=radio id="datelimit" formControlName="datelimit" value="all" (click)="refreshInvoices('all'); $event.stopPropagation()">All Invoices-->
    </form>
</div>
<hr>
<div class="container divtable">
    <div class="divtablebody">
        <div class=" divrow">

            <div class="coltitle col-md-2 appcol invnumcolinv">Inv#</div>
                
            <div class="coltitle col-md-2 appcol datecolinv">Inv. Date</div>
            
            <div class="coltitle  col-md-2 appcol desccolinv">Customer</div>
            
            <div class="coltitle  col-md-2 appcol productcolinv">Product</div>

            <div class="coltitle col-md-2 appcol linecolinv">Line</div>
            
            <div class="coltitle col-md-2 appcol datecolinv">Uploaded</div>

            <div class="coltitle  col-md-2 appcol btncolinv">&nbsp;</div>
            
        </div>
        
        @for (invoice of invoices; track invoice.id) {
        <div class=" divrow"  (click)="onEdit(invoice)">

            <div class="col-md-2 appcol invnumcolinv appcell">{{invoice.invoiceno}}</div>
                    
            <div class="col-md-2 appcol datecolinv appcell">{{invoice.invoicedate | date:'MM/dd/yyyy'}}</div>
                    
            <div class="col-md-2 appcol desccolinv appcell">{{invoice.customercode+": "+invoice.customername}}</div>

            <div class="col-md-2 appcol productcolinv appcell">{{invoice.productcode}}</div>

            <div class="col-md-2 appcol linecolinv appcell">{{ invoice.lineno == null ? '&nbsp;' : invoice.lineno}}</div>

            <div class="col-md-2 appcol datecolinv appcell">{{ invoice.uploaded == '0000-00-00' ? 'Pending' : invoice.uploaded}}</div>

            <div class="col-md-2 appcol btncolinv">
              <button class="delete btn-xs btn-danger" (click)="deleteInvoice(invoice); $event.stopPropagation()">Delete</button>    
            </div>
        </div>
        }
    </div>
</div>

